import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getDisputesForPaginationOrix,
} from "slices/disputeSlice";
import DisputesOrixUser from "./DisputesOrixUser";
import { usePagination } from "hooks";
import { ROWS_PER_PAGE } from "../config";

export const typeChoices = ["open", "closed"];

export default function DisputesContainerOrixUser() {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile, shallowEqual);
  const user = useSelector((state) => state.user.user);

  const { page, setPage, totalPages, syncWithBackend } = usePagination({
    initialPage: 1,
    initialPageSize: ROWS_PER_PAGE,
  });

  let sessionType = sessionStorage.getItem("orix-type");
  const [type, setType] = useState(sessionType ? sessionType : 'open');
  const [disputes, setDisputes] = useState([]);
  const [disputesLoading, setDisputesLoading] = useState(false);

  useEffect(()=>{
    reload(type);
  },[type])

  const reload = (newType = type) => {
    setDisputesLoading(true);
    setPage(1);
    dispatch(getDisputesForPaginationOrix(1, newType, null, null)).then((res) => {
      syncWithBackend({totalCount: res?.count, next: res?.next, previous: res?.previous});
      setDisputes(res.results);
      setDisputesLoading(false);
    });
  };

  const getUserDataAnotherPage = (pageNo) => {
    if(pageNo === page) return;
    setDisputesLoading(true);
    setPage(pageNo)
    dispatch(getDisputesForPaginationOrix(pageNo, type, null, null)).then((res) => {
      setDisputes(res.results);
      setDisputesLoading(false);
    });
  };

  let childProps = {
    disputes,
    profile,
    user,
    disputesLoading,
    setType,
    type,
    reload,
    totalPages,
    currentPage: page,
    setCurrentPage: setPage,
    getUserDataAnotherPage,
    profile
  };

  if (disputesLoading) return <CircularCenteredLoader />;
  return <DisputesOrixUser {...childProps} />;
}
